import React from 'react';
import './Banner.css';

import { Heading, Button } from '../../components'; // Importing reusable Heading and Button components



const Banner = () => {
  return (
    <section className="banner">
      <div className="content">

        <Heading
          title={'Discover, Engage & Grow with Industry Leaders'}
          subTitle={'Join the Experience'}
          linear
          sideHeading
        />

        <Button link={'Registration'} title={'Register Now'} />

      </div>
    </section>
  );
};

export default Banner;